import { Link } from '@tanstack/react-router'
// eslint-disable-next-line no-restricted-imports
import { Breadcrumb as AntdBreadcrumb } from 'antd'
import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { tenantStore } from '@/routes/_protected/$tenantKey/-states'
import { queryParamHistoryAtom } from '@/routes/_protected/$tenantKey/-states/atoms/query-param-history.atom'

type Props = ComponentPropsWithoutRef<typeof AntdBreadcrumb>

/**
 * Antd の Breadcrumb をラップしたコンポーネント
 * - フォントを太字に設定
 */
export const Breadcrumb: FC<Props> = ({ className, ...props }) => {
  return (
    <AntdBreadcrumb
      className={clsx(['font-bold', className])}
      itemRender={itemRender}
      {...props}
    />
  )
}

const itemRender: Props['itemRender'] = (route, _params, routes) => {
  const isLast = routes.at(-1) === route
  const history = tenantStore.get(queryParamHistoryAtom)
  const search = history?.path == route.href ? history?.params : undefined

  return isLast ? (
    route.title
  ) : (
    <Link to={route.href} search={search}>
      {route.title}
    </Link>
  )
}
